
<mat-toolbar class="topbar" color="primary">
  <span class="title">AWS Cloud Readiness Assessment</span>
  <span class="spacer"></span>
  <button mat-stroked-button (click)="toggleResults()">View Assessment</button>
</mat-toolbar>

<div class="container">
  <mat-progress-bar mode="determinate" [value]="progressPercentage"></mat-progress-bar>
  <div class="progress-text">({{answeredCount}}/{{totalQuestions}} answered) — {{progressPercentage}}%</div>

  <mat-tab-group [(selectedIndex)]="activeTabIndex">
    <mat-tab *ngFor="let section of sections" [label]="section.title">
      <!-- <div class="section-header">
        <h3>{{section.title}}</h3>
        <p>{{section.description}}</p>
      </div> -->
      <div class="questions">
        <mat-card *ngFor="let q of section.questions" id="q-{{q.id}}">
          <mat-card-title>{{q.title}}</mat-card-title>
          <mat-card-content>
            <p>{{q.text}}</p>
            <mat-radio-group [formControl]="form.controls[q.id]" (change)="onAnswerChange(section.id, q.id)">
              <mat-radio-button value="1">1 - No / I don't know.</mat-radio-button><br>
              <mat-radio-button value="2">2 - Starting to think about it.</mat-radio-button><br>
              <mat-radio-button value="3">3 - Experimenting with pilot initiatives.</mat-radio-button><br>
              <mat-radio-button value="4">4 - Yes, but inconsistently implemented across the organization.</mat-radio-button><br>
              <mat-radio-button value="5">5 - Yes, and consistently implemented across the organization.</mat-radio-button>
            </mat-radio-group>
          </mat-card-content>
        </mat-card>
      </div>
    </mat-tab>
  </mat-tab-group>

  <div class="footer-controls">
    <button mat-button (click)="prevSection()" [disabled]="activeTabIndex === 0">Previous section</button>
    <button mat-button (click)="goToNextUnanswered()">Next unanswered</button>
    <span class="spacer"></span>
    <button mat-raised-button color="accent" (click)="nextSection()" [disabled]="activeTabIndex >= sections.length - 1">Next section</button>
  </div>

  <div class="results-panel" *ngIf="showResults">
    <h3>Assessment Answers</h3>
    <pre>{{answersJson}}</pre>
    <button mat-stroked-button (click)="exportResults()">Export JSON</button>
    <button mat-button color="warn" (click)="clearAnswers()">Clear answers</button>
  </div>
</div>